import { useTranslation } from 'react-i18next';
import { ButtonSmall, Loader } from '@/shared/components';
import { useScrollTrigger } from '@/shared/lib/useScrollTrigger';

type Props = {
  hasMore: boolean;
  isFetchingMore: boolean;
  isLoadMoreError: boolean;
  isLoadMoreRequired: boolean;
  onReachEnd: () => void;
  onLoadMore: () => void;
  onRetry: () => void;
};

const LoadTrigger = ({ onEnter }: { onEnter: () => void }) => {
  const ref = useScrollTrigger({
    onEnter,
    rootMargin: '200px',
    threshold: 0,
    triggerOnce: false,
  });

  return <div ref={ref} className="h-px" />;
};

export const HistoryListFooter = ({
  hasMore,
  isFetchingMore,
  isLoadMoreError,
  isLoadMoreRequired,
  onReachEnd,
  onLoadMore,
  onRetry,
}: Props) => {
  const { t } = useTranslation();

  if (isFetchingMore) {
    return <Loader className="h-[5.6rem] text-secondary" />;
  }

  if (isLoadMoreError) {
    return (
      <div className="flex flex-col items-center gap-[1.2rem] py-[1.6rem]">
        <p className="p5 text-secondary text-center">
          {t('historyPage.loadError.title')}
        </p>
        <ButtonSmall className="pl-[1.2rem]" onClick={onRetry}>
          {t('historyPage.loadError.retry')}
        </ButtonSmall>
      </div>
    );
  }

  if (!hasMore) return null;

  if (isLoadMoreRequired) {
    return (
      <div className="flex justify-center py-[1.6rem]">
        <ButtonSmall className="pl-[1.2rem]" onClick={onLoadMore}>
          {t('historyPage.loadMore')}
        </ButtonSmall>
      </div>
    );
  }

  return <LoadTrigger onEnter={onReachEnd} />;
};
